import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-document-checked",
  "use": "icon-si-glyph-document-checked-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-document-checked\" id=\"icon-si-glyph-document-checked\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>118</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#434343\">\n            <path d=\"M9.024,0.016 L9.024,3.995 L13.971,3.995 L9.024,0.016 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M8,5.062 L8,0 L2.008,0 L2.008,12.745 L2.444,13.182 L4.579,11.046 L6.688,13.151 L3.887,15.953 L14,15.953 L14,5 L8,5.062 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M4.58,12.46 L2.444,14.596 L1.045,13.196 L0.352,13.889 L2.444,15.981 L5.273,13.152 L4.58,12.46 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-document-checked.svg
// module id = jdcq
// module chunks = 62